import React from 'react';
import FuelInventory from './FuelInventory';

import Inventory from './Inventory';

const FuelInventoryConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: ['super-admin', 'power dispatcher'],
  routes: [
    {
      path: '/fuel-inventory',
      component: FuelInventory,
      exact: true,
    },
    {
      path: '/fuel-inventory/inventory',
      component: Inventory,
      exact: true,
    },
      {
        path: '/fuel-inventory/transactions',
        component: require('./Transactions').default,
        exact: true,
      },
  ],
};

export default FuelInventoryConfig;
